import axios from "axios";

//apply base url for axios
let API_URL = "";
switch (process.env.REACT_APP_STATUS) {
  case "DEV":
    API_URL = process.env.REACT_APP_DEV_URL;
    break;
  case "STAGE":
    API_URL = process.env.REACT_APP_STAGE_URL;
    break;
  case "PROD":
    API_URL = process.env.REACT_APP_PROD_URL;
    break;
}

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
